import * as React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';//取得のみ
import { useTranslation } from 'react-i18next';

import { nftJsonState } from "../../states/nftJsonState";
import { getedNFTState } from "../../states/getedNFTState";

type Props = {

}

//NFTInfoText コンポーネントの定義
export const NFTInfoTextPlusURL: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const nftInfo = useRecoilValue(nftJsonState);
  const getedNFTStatus = useRecoilValue(getedNFTState);

  const nftinfoStyle: React.CSSProperties = {
    marginBottom: '50px',
    position: 'relative',
    marginTop: '15px',
  };
  const nftInfoNameStyle: React.CSSProperties = {
    fontWeight: 900,
    fontSize: '24px',
    marginBottom: 0,
    fontFamily: "Noto Sans JP,sans-serif",
  };
  const nftInfoDescriptionStyle: React.CSSProperties = {
    fontWeight: 400,
    fontSize: '16px',
    marginBottom: 0,
    fontFamily: "Noto Sans JP,sans-serif",
  };
  const NFTInfoUrlComponent = styled.a`
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-decoration-line: underline;
    width: 301px;
    font-family: 'Noto Sans JP',sans-serif;
    
    color: white;
    display: block;
  `;
  const NFTInfo = styled.div`
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 35px;

    align-items: center;
    color: #FFFBFB;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0 auto;
    padding: 0;
    position: relative;
    text-align: start;
    width: 264px;
    
    &::before {
      width: 2px;
      height: 100%;
      background: #FFFBFB;
      border: 2px solid #FFFBFB;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      position: absolute;
      content: "";
      display: inline-block;
      left: -13px;
      top: 0;
    }
  `;
  // width: 301px;

  return (
      <div id='NFTinfo' style={nftinfoStyle}>
        <NFTInfo>
          <p className='text-start' id='NFTinfoname' style={nftInfoNameStyle}>{getedNFTStatus.name}</p>
          <p className='text-start' id='NFTinfodescription' style={nftInfoDescriptionStyle} dangerouslySetInnerHTML={{__html:`${getedNFTStatus.description.replace(/\n/g, '<br/>')}`}}></p>
          {/* <NFTInfoUrlComponent id='NFTinfourl' href={`https://www.sushitopmarketing.com/help`} target ="_blank">{t(`ヘルプページ`)}→</NFTInfoUrlComponent> */}
        </NFTInfo>
      </div>
  );
};